import dayjs from "~/lib/dayjs";

/**
 * Get timezone abbreviation
 * @param {string} timezone - IANA timezone name (e.g., 'America/New_York')
 * @returns {string} Timezone abbreviation (e.g., 'EST') or offset (e.g., 'GMT+1')
 */
export const getTimezoneName = (timezone) => {
  if (!timezone) {
    return null;
  }

  // Special case for Arizona (no DST)
  if (timezone === "America/Phoenix") {
    return "Arizona";
  }

  try {
    return dayjs().tz(timezone).format("z");
  } catch {
    return timezone;
  }
};
